<template>
  <div
    id="events"
    class="container-fluid mt-3">
    <div
      class="row mb-3"
      v-for="e in eventsIncludingHidden"
      :key="e.id">

      <div class="col-lg-auto pr-0">
        <!-- Event Name -->
        <h3 class="text-center text-lg-left">
          {{e.name}}
        </h3>
        <!-- / Event Name -->

        <!-- Roster Status -->
        <div
          v-if="!e.registration_open && e.waitlist_open"
          class="text-danger text-center text-lg-left mt-n2 mb-2">
          Only the waitlist is open at this time.
        </div>
        <!-- / Roster Status -->

        <!-- Roster Status -->
        <div
          v-if="!e.registration_open && !e.waitlist_open"
          class="text-danger text-center text-lg-left mt-n2 mb-2">
          Registration (including waitlist) is not open at this time.
        </div>
        <!-- / Roster Status -->

        <!-- Event Details -->
        <h6 class="event-details">
          <!-- Registration Open -->
          <div class="d-flex mb-1">
            <div class="label text-highlight mr-3 text-right ml-auto">
              Registration Open:
            </div>
            <div class="mr-auto">
              {{e.display_registration_start_date_time}}
            </div>
          </div>
          <!-- / Registration Open -->

          <!-- Registration Closed -->
          <div class="d-flex mb-1">
            <div class="label text-highlight mr-3 text-right ml-auto">
              Registration Closed:
            </div>
            <div class="mr-auto">
              {{e.display_registration_end_date_time}}
            </div>
          </div>
          <!-- / Registration Closed -->

          <!-- Event Start -->
          <div class="d-flex mb-1">
            <div class="label text-highlight mr-3 text-right ml-auto">
              Event Start:
            </div>
            <div class="mr-auto">
              {{e.display_start_date_time}}
            </div>
          </div>
          <!-- / Event Start -->

          <!-- Event End -->
          <div class="d-flex">
            <div class="label text-highlight mr-3 text-right ml-auto">
              Event End:
            </div>
            <div class="mr-auto">
              {{e.display_end_date_time}}
            </div>
          </div>
          <!-- / Event End -->
        </h6>
        <!-- / Event Details -->
      </div>

      <!-- Pricing -->
      <div
        style="overflow-x: auto;"
        class="pricing col-lg-auto d-flex flex-column pr-lg-0">

        <table
          class="my-auto mx-auto mx-lg-0"
          v-if="orderedPricing(e).length > 0">
          <thead>
            <tr class="text-highlight">
              <th class="text-right pr-3">Cost</th>
              <th>Description</th>
              <th>Age</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="price in orderedPricing(e)"
              :key="price.id">
              <td class="price-price text-right pr-3">{{price.price | currency}}</td>
              <td class="price-label text-truncate" :title="price.label">{{price.label}}</td>
              <td class="price-age">
                <span v-if="price.min_age && price.max_age">{{price.min_age}}-{{price.max_age}}</span>
                <span v-else-if="price.max_age">{{price.max_age}} and down</span>
                <span v-else-if="price.min_age">{{price.min_age}} and up</span>
                <span v-else>n/a</span>
              </td>
            </tr>
          </tbody>
        </table>

        <h5
          class="no-price my-auto mx-auto mx-lg-0"
          v-if="e.pricing_packages.length === 0">
          No pricing for this event yet.
        </h5>
      </div>
      <!-- / Pricing -->

      <div class="d-none d-lg-flex flex-fill"></div>

      <!-- Register -->
      <div class="
        register
        col-lg-auto
        d-flex align-items-center
        mt-3 mx-auto">
        <b-button
          type="button"
          class="w-100"
          variant="primary"
          @click="goToEvent(e)"
          :disabled="!eventStatus(e).canRegister">
          <span v-if="eventStatus(e).canRegister && e.registration_open">
            Register
          </span>
          <span v-else-if="eventStatus(e).canRegister && e.waitlist_open">
            Register for Waitlist
          </span>
          <span v-else-if="!eventStatus(e).canRegister">
            Registration Closed
          </span>
        </b-button>
      </div>
      <!-- / Register -->

      <hr class="w-100 mx-3 mb-0">
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import AppMixin from '../services/mixin.app';

export default {
  name: 'events',
  mixins: [AppMixin],
  computed: {
    eventsIncludingHidden() {
      return _(this.events)
        .concat(this.hiddenEvents)
        .filter(e => e.org_id === this.organizationID)
        .uniqBy('id')
        .orderBy('start_date_time')
        .value();
    },
  },
  methods: {
    orderedPricing(e) {
      return _.orderBy(e.pricing_packages, 'price');
    },
  },
};
</script>

<style lang="scss">
#events {
  .register {
    width: 190px;
  }

  @media (min-width: 992px) {
    .no-price {
      width: 521px;
    }
  }

  table {
    border: none;
    display: block;
    padding-right: 1rem;

    tr, td, th {
      border: none;

      &:not(.text-right):not(.text-center) {
        text-align: left !important;
      }
    }

    thead {
      background-color: #f0f3fd;
    }

    tbody {
      tr:nth-child(even) {
        background-color: #f0f3fd;
      }
      tr:nth-child(odd) {
        background-color: #d9e1fb;
      }
    }

    .price-label {
      max-width: 275px;
      min-width: 275px;
    }

    .price-price,
    .price-fess,
    .price-age {
      max-width: 100px;
      min-width: 100px;
    }
  }
}
</style>
